
	import {
		Component,
		Vue,
		Inject,
		Prop,
		Watch
	} from 'vue-property-decorator';
	import Util from '@/lib/util'
	import AbpBase from '@/lib/abpbase'
	import PageRequest from '@/store/entities/page-request'
	import Property from '@/store/entities/property'
	import Tag from '@/store/entities/tag'
	import DataSet from '@antv/data-set'
	import selectSearch from '../components/selectSearch.vue'
	import {
		Chart
	} from '@antv/g2'
	class UserRequest {
		typesArray: any = [];
		types: string = '';
		organizationId: number = null;
		startTime: Date;
		endTime: Date;
		dateType: string = '0';
	}
	class AppRequest {
		appName: string = '';
		organizationId: number = null;
		startTime: Date;
		endTime: Date;
		dateType: string = '0';
		type:string = '0';
	}
	class NewsRequest {
		type: number = 0;
		organizationId: number = null;
		startTime: Date;
		endTime: Date;
		dateType: string = '0';
	}
	@Component({
		components:{
			selectSearch
		}
		
	})

	export default class Statistics extends AbpBase {
		orgList: Array < any >= new Array < any > ();
		orgs: Array < any >= new Array < any > ();
		userRequest: UserRequest = new UserRequest();
		appRequest: AppRequest = new AppRequest();
		newsRequest: NewsRequest = new NewsRequest();
		userStatistics: any = {
			newUserCount: 0,
			activeUserCount: 0,
			newUserRate: 0,
			activeUserRate: 0,
			visitUserCount:0
		};
		appStatistics: any = {
			appCounts: []
		};
		newsStatistics: any = {
			NewsCounts: []
		};
		
		
 
		lang:string='chs';
		dispuser:Object={
			en:'user',
			chs:'用户'
		};
		dispapplication:Object={
			en:'application',			chs:'应用'
		};
		dispnews:Object={
			en:'news',
			chs:'新闻'
		};
		dispselect:Object={
			en:'Please select a department',
			chs:'请选择部门'
		};
		dispmonth:Object={
			en:'Nearly a month',
			chs:'近一个月'
		};
		dispweek:Object={
			en:'Nearly a week',
			chs:'近一周'
		};
		dispnewuser:Object={
			en:'New user',
			chs:'新增用户'
		};
		dispactiveuser:Object={
			en:'Active user',
			chs:'活跃用户'
		};
		dispvisits:Object={
			en:'Visits',
			chs:'访问人次'
		};
		dispviews:Object={
			en:'Views',
			chs:'浏览量'
		};
		dispusers:Object={
			en:'Users',
			chs:'用户数'
		};
		displikes:Object={
			en:'likes',
			chs:'点赞'
		};
		dispshare:Object={
			en:'share',
			chs:'分享'
		};
		dispcomment:Object={
			en:'comment',
			chs:'评论'
		};
		
		
		

		userChart: any = null;
		appChart: any = null;
		newsChart: any = null;
		tabIndex: number = 0;
		created() {
			var that = this;
			that.userRequest.typesArray = [0];
			that.appRequest.startTime = new Date((new Date).getTime() - 30 * 24 * 60 * 60 * 1000);
			that.appRequest.endTime = new Date();
			that.newsRequest.startTime = new Date((new Date).getTime() - 30 * 24 * 60 * 60 * 1000);
			that.newsRequest.endTime = new Date();
			that.loadOrg();
			that.showUser();
			
			
			var local=that.$route.query.local as any;
			if (local != undefined && local != null && local != '') {
				that.lang=local;
			}
			var title=that.$route.query.title as any;
			if (title != undefined && title != null && title != '') {
				document.title=title;
			}
			else{
				document.title="活跃度统计";
			}

		}
		tabChange(index) {
			var that = this;
			this.tabIndex = index;
			switch (index) {
				case 0:
					that.showUser();
					break;
				case 1:
					that.showApp();
					break;
				case 2:
					that.showNews();
					break;
			}
		}
		loadOrg() {
			var that = this;
			that.$store.dispatch({
				type: 'user/getOrganizationList',
				data: {
					SkipCount: 0,
					MaxResultCount: 1000,
					Keyword: '',
					ParentId: 0,
					Top: false
				}
			}).then((res) => {
				if (res.success) {
					var orgList = res.result.items;
					orgList.unshift({
						"type": 0,
						"description": "",
						"externalId": "",
						"externalParentId": "",
						"code": "",
						"parentId": null,
						"displayName": "全部",
						"order": 0,
						"id": '',
					});

					var newOrgs = [];
					for (var i = 0; i < orgList.length; i++) {
						var org = orgList[i];
						if (org.parentId == null) {
							newOrgs.push(org);
							for (var j = 0; j < orgList.length; j++) {
								var org1 = orgList[j];
								if (org1.parentId == org.id) {
									org1.displayName = "--" + org1.displayName;
									newOrgs.push(org1);
									for (var k = 0; k < orgList.length; k++) {
										var org2 = orgList[k];
										if (org2.parentId == org1.id) {
											org2.displayName = "----" + org2.displayName;
											newOrgs.push(org2);
											for (var l = 0; l < orgList.length; l++) {
												var org3 = orgList[l];
												if (org3.parentId == org2.id) {
													org3.displayName = "------" + org3.displayName;
													newOrgs.push(org3);

												}
											}
										}
									}

								}

							}

						}

					}
					that.orgList = newOrgs;
					that.orgs = newOrgs;
					// that.orgs = that.getOrgTreeData();
				}
			})
		}
		getOrgTreeData() {
			var that = this;
			var orgList = that.orgList;
			var data = [];
			for (let i = 0; i < orgList.length; i++) {
				data.push({
					id: orgList[i].id,
					parentId: orgList[i].parentId,
					title: orgList[i].displayName,
					checked: false
				});
			}
			let productTypeList = data // 这个就是后台拿到的数据data
			// 删除所有 children,以防止多次调用(这一步是最后执行完之后加上的,因为不删除会多次调用)
			productTypeList.forEach(el => {
				delete el.children
			})

			let map = {}
			productTypeList.forEach(el => {
				map[el.id] = el // 循环data拿到所有的id
			})

			let arr = []
			productTypeList.forEach(el => {
				let parent = map[el.parentId] // 拿到所有的pid,如果为真,和id进行对比,如果pid===id,就说明是id的子集


				if (parent) {
					(parent.children || (parent.children = [])).push(el)
				} else {
					// 如果不是就是第一级,没有pid或者pid为0
					arr.push(el)
					// console.log('arr', arr)
				}
			})
			return arr
		}
		confirmOrg() {

		}
		userTabChange(type) {
			var index = this.userRequest.typesArray.indexOf(type);
			var arr=[];arr.push(type);
			this.userRequest.typesArray=arr;
			// var index = this.userRequest.typesArray.indexOf(type);
			// if (index > -1) {
			// 	this.userRequest.typesArray.splice(index, 1);
			// } else {
			// 	this.userRequest.typesArray.push(type);
			// }
			this.showUser();
		}
		appTabChange(name) {
			this.appRequest.appName = name;
			this.showApp();
		}
		newsTabChange(type) {
			this.newsRequest.type = type;
			this.showNews();
		}
		showUser() {
			var that = this;
			
			that.$Message.loading({
			    content: 'loading',
			    duration: 0,
			   });
			   
			if(that.userRequest.dateType == "0"){
				that.userRequest.startTime = new Date((new Date).getTime() - 30 * 24 * 60 * 60 * 1000);
				that.userRequest.endTime = new Date();
			}
			if(that.userRequest.dateType == "1"){
				that.userRequest.startTime = new Date((new Date).getTime() - 7 * 24 * 60 * 60 * 1000);
				that.userRequest.endTime = new Date();
			}
			
			if (that.userRequest.typesArray.length == 0 && that.userChart != null) {
				that.userChart.destroy();
				that.userChart = null;
				return;
			}
			that.userRequest.types = JSON.stringify(that.userRequest.typesArray);
			that.$store.dispatch({
				type: 'app/getUserStatistics',
				data: that.userRequest
			}).then((res) => {
				
				that.$Message.destroy();
							
				that.userStatistics = res;
				if (res.preNewUserCount * 1 > 0) {
					that.userStatistics.newUserRate = (res.newUserCount - res.preNewUserCount / res.preNewUserCount).toFixed(2);
				}
				if (res.allUserCount * 1 > 0) {
					that.userStatistics.activeUserRate = (res.activeUserCount * 100 / res.allUserCount).toFixed(2);
				}
				var data1 = [];
				for (let key in res.newDailyCount) {
					var item = {
						date: key,
						value: res.newDailyCount[key]
					};
					data1.push(item);
				}
				var data2 = [];
				for (let key in res.activeDailyCount) {
					var item = {
						date: key,
						value: res.activeDailyCount[key]
					};
					data2.push(item);
				}
				var data3 = [];
				for (let key in res.visitDailyCount) {
					var item = {
						date: key,
						value: res.visitDailyCount[key]
					};
					data3.push(item);
				}
				if (that.userChart != null) {
					that.userChart.destroy();
				}

				that.userChart = new Chart({
					container: 'userChart',
					autoFit: true,
					height: 300,
					padding: [20, 20],
				});
				that.userChart.scale({
					value: {
						sync: true,
						nice: true,
					}
				});
				if (that.userRequest.typesArray.indexOf(0) > -1) {
					const ds1 = new DataSet();
					const dv1 = ds1.createView().source(data1);
					dv1.transform({
						type: 'map',
						callback: (row) => {
							row.date = row.date.substr(5, 5);
							return row;
						}
					});
					const view1 = that.userChart.createView();
					view1.data(dv1.rows);
					view1.axis('date', {
						subTickLine: {
							count: 3,
							length: 3,
						},
						tickLine: {
							length: 6,
						},
					});
					view1.axis('value', {
						label: {
							formatter: text => {
								return text;
							}
						}
					});
					view1.interval().position('date*value').color('#1890ff').label('value');
					

				}
				if (that.userRequest.typesArray.indexOf(1) > -1) {					
					const ds2 = new DataSet();
					const dv2 = ds2.createView().source(data2);
					dv2.transform({
						type: 'map',
						callback: (row) => {
							row.date = row.date.substr(5, 5);
							return row;
						}
					});
					const view2 = that.userChart.createView();
					view2.data(dv2.rows);
					view2.axis('date', {
						subTickLine: {
							count: 3,
							length: 3,
						},
						tickLine: {
							length: 6,
						},
					});
					view2.axis('value', {
						label: {
							formatter: text => {
								return text;
							}
						}
					});
					view2.line().position('date*value').color('#2fc25b').label('value');
				
				}
				if (that.userRequest.typesArray.indexOf(2) > -1) {
					const ds3 = new DataSet();
					const dv3 = ds3.createView().source(data3);
					dv3.transform({
						type: 'map',
						callback: (row) => {
							row.date = row.date.substr(0, 10);
							return row;
						}
					});
					const view3 = that.userChart.createView();
					view3.data(dv3.rows);
					view3.axis('date', {
				
						subTickLine: {
							count: 3,
							length: 3,
						},
						tickLine: {
							length: 6,
						},
					});
					view3.axis('value', {
						label: {
							formatter: text => {
								return text;
							}
						}
					});
					view3.line().position('date*value').color('#2fc25b').label('value');
				}
				
 
				that.userChart.render();


				// that.showChart(that.userChart, data);
			});

		}
		showApp() {
			var that = this;
			
			that.$Message.loading({
			    content: 'loading',
			    duration: 0,
			   });
			   
			if(that.appRequest.dateType == "0"){
				that.appRequest.startTime = new Date((new Date).getTime() - 30 * 24 * 60 * 60 * 1000);
				that.appRequest.endTime = new Date();
			}
			if(that.appRequest.dateType == "1"){
				that.appRequest.startTime = new Date((new Date).getTime() - 7 * 24 * 60 * 60 * 1000);
				that.appRequest.endTime = new Date();
			}
			that.$store.dispatch({
				type: 'app/getAppStatistics',
				data: that.appRequest
			}).then((res) => {
				
				that.$Message.destroy();
							
				that.appStatistics = res;
				that.appStatistics.appCounts = [];
				for (let key in res.appCount) {
					var item1 = {
						name: key,
						count: res.appCount[key]
					};
					that.appStatistics.appCounts.push(item1);
				}

				if (that.appRequest.appName == '' && that.appStatistics.appCounts.length > 0) {
					that.appRequest.appName = that.appStatistics.appCounts[0].name;
				}
				var data = [];
				for (let key in res.dailyCount) {
					var item = {
						date: key.substr(5, 5),
						value: res.dailyCount[key]
					};
					data.push(item);
				}
				if (that.appChart != null) {
					that.appChart.destroy();
					that.appChart = null;
				}

				that.appChart = new Chart({
					container: 'appChart',
					autoFit: true,
					height: 320,
					// padding: [20, 40],
				});
				that.appChart.data(data);
				// that.appChart.scale('value', {
				// 	alias: '访问数',
				// });

				// that.appChart.axis('date', {
				// 	tickLine: {
				// 		alignTick: false,
				// 	},
				// });
				// that.appChart.axis('value', false);

				// that.appChart.tooltip({
				// 	showMarkers: false,
				// });
				that.appChart.interval().position('date*value').label('value');
				that.appChart.interaction('element-active');
				that.appChart.render();

				// that.showChart(that.appChart, data);
			});

		}
		showNews() {
			var that = this;
			
			that.$Message.loading({
			    content: 'loading',
			    duration: 0,
			   });
			
			if(that.newsRequest.dateType == "0"){
				that.newsRequest.startTime = new Date((new Date).getTime() - 30 * 24 * 60 * 60 * 1000);
				that.newsRequest.endTime = new Date();
			}
			if(that.newsRequest.dateType == "1"){
				that.newsRequest.startTime = new Date((new Date).getTime() - 7 * 24 * 60 * 60 * 1000);
				that.newsRequest.endTime = new Date();
			}
			that.$store.dispatch({
				type: 'app/getNewsStatistics',
				data: that.newsRequest
			}).then((res) => {
				
				that.$Message.destroy();
				
				that.newsStatistics = res;
				that.newsStatistics.newsCounts = [];
				for (let key in res.newsCount) {
					var item1 = {
						type: key,
						count: res.newsCount[key]
					};
					that.newsStatistics.newsCounts.push(item1);
				}
				var data = [];
				for (let key in res.dailyCount) {
					var item = {
						date: key.substr(2,8),
						value: res.dailyCount[key]
					};
					data.push(item);
				}
				if (that.newsChart != null) {
					that.newsChart.destroy();
					that.newsChart = null;
				}
				that.newsChart = new Chart({
					container: 'newsChart',
					autoFit: true,
					height: 320,
					// padding: [20, 40],
				});

				that.showChart(that.newsChart, data);
			});

		}
		showChart(chart, data) {
			chart.scale({
				value: {
					sync: true,
					nice: true,
				}
			});
			const ds = new DataSet();
			const dv1 = ds.createView().source(data);
			
			const view1 = chart.createView();
			view1.data(dv1.rows);
			view1.axis('date', {

				subTickLine: {
					count: 3,
					length: 3,
				},
				tickLine: {
					length: 6,
				},
			});
			view1.axis('value', {
				label: {
					formatter: text => {
						return text;
					}
				}
			});
			view1.line().position('date*value').label('value');
			chart.render();
		};
	}
